import { render } from "./App.vue?vue&type=template&id=60534787"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/dev.admin.nikted.ir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__